import fetch from './fetch';

//图片列表
export function reqPicList(data) {
    return fetch({
        url: '/zt/360phonecyj/index.php?mod=getPicList',
        method: 'post',
        data
    });
}
//上传音频
export function reqFileupload(data) {
    return fetch({
        url: '/zt/luyin/fileupload.php',
        method: 'post',
        data
    });
}
//保存音频
export function reqVideosub(data) {
    return fetch({
        url: '/zt/luyin/videosub.php',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/https.js